import React from 'react';
import { useSelector } from 'react-redux';
import VImage from '../VImage/VImage';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Background = props => {
  const design = useSelector(state => state.design);
  const background = useSelector(
    state => _.get(state, ['design', 'pages', props.pageId, 'background'], {}),
  );
  let media;

  if (_.has(background, 'media.src')) {
    media = {
      src: background.media.src,
      innerStyle:
        background.media.style && background.media.style.inner ? background.media.style.inner : {},
      // : { width: design.width, height: design.height },
      flip:
        background.media.style && background.media.style.flip ? background.media.style.flip : {},
      filter:
        background.media.filter && background.media.filter.code
          ? background.media.filter.code
          : '6464646464646432',
      type: background.media.type,
    };
  }
  if (props.src) {
    media = { ...media, src: props.src, type: props.type };
  }
  const minWidth = design.width;
  const minHeight = design.width;
  const imageMinSize = { width: minWidth, height: minHeight };
  return (
    <>
      {media && media.src && (
        <VImage
          entityId={-1}
          src={media.src}
          style={media.innerStyle}
          flip={media.flip}
          filter={media.filter}
          type={media.type}
          keyId="Background"
          dataTarget={`B_${props.pageId}`}
          internal
          background
          parentSize={imageMinSize}
        />
      )}
    </>
  );
};

Background.propTypes = {
  src: PropTypes.string,
  type: PropTypes.string,
  data: PropTypes.object,
  pageId: PropTypes.number,
};

export default Background;
